"use client";
import { useEffect, useRef } from "react";


const BackgroundVideo: React.FC = () => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.load();
    }
  }, []);

  return (
    <div className="absolute inset-0 w-full h-full overflow-hidden">
      <video
        ref={videoRef}
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        className="w-full h-full object-cover opacity-0 transition-opacity duration-300"
        onLoadedData={(e) => {
          const videoElement = e.target as HTMLVideoElement;
          videoElement.classList.remove("opacity-0");
          videoElement.classList.add("opacity-100");
        }}
      >
        <source src="/bgVD.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      {/* Overlay with black semi-transparent background */}
      <div className="absolute inset-0 bg-black/40 z-10" />
    </div>
  );
};

export default BackgroundVideo;
